import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
  WithStyles,
  createStyles,
  Button,
  Grid,
  Typography,
  Modal,
  Theme,
  Card,
  CardHeader,
  IconButton,
  CardContent,
  LinearProgress,
} from '@material-ui/core';
import { connect } from 'react-redux';
import { showAudioModal } from '../mylibrary/actions/showAudioProgressActions';
import * as focusedSectionActions from "./actions/focusedSectionAction";

const styles = (theme: Theme) =>
  createStyles({
    dashedBorder: {
      border: 'dashed 1px #000',
      padding: 8,
      borderRadius: 4,
    },

    dashedBlock: {
      width: 600,
      margin: 20,
      height: 240,
    },

    fontSize2X: {
      fontSize: 15,
    },
    lineHeight2X: {
      lineHeight: 20,
    },

    typographyStyle: {
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: '15px',
      lineHeight: '20px',
      width: '100%',
    },

    modal: {
      display: 'flex',
      padding: 12,
      alignItems: 'center',
      justifyContent: 'center',
    },

    modalHeader: {
      height: 60,
      borderBottom: 'solid 1px #0004',
    },

    subHeadingFont: {
      fontSize: '1rem',
      fontStyle: 'normal',
      fontWeight: 'bold',
    },

    margin1X: {
      margin: '6px',
    },
    buttonRoundBorder: {
      borderRadius: 0,
    },
    cardContent: {
      overflow: 'hidden',
    },
    dragDropVideoContainer: {
      border: 'dashed 1px #999',
      padding: '20px 12px 10px !important',
      textAlign: 'center',
      borderRadius: '5px',
      width: '170px',
      position: 'relative',
      marginBottom: '7px',
      pointerEvents: 'initial',
      "& input[type=text]": {
        position: "absolute",
        bottom: 0,
        left: 0,
        right: 0,
        margin: "0 auto",
      },
    },
    dragDropVideoText: {
      color: '#a9a9a9',
      fontSize: '14px',
      fontWeight: 'normal',
      width: '140px',
      lineHeight: '18.2px',
      display: 'inline-block',
    },
  });

interface MathPixDataInterface {
  confidence: number;
  confidenceRate: number;
  text: string;
  html: string;
}

//@ts-ignore
interface MyPATAudioUploadProps extends WithStyles<typeof styles> {
  classes: any;
  showAudioModal: Function;
  handleAudioSelect: Function;
  audioUploadHandler: Function;
  focusSection: Function;
}
interface MyPATAudioUploadState {
  isUpload: boolean;
  uploadImage: string;
  isOpenUploadDialog: boolean;
  completed: number;
  mathPixData: null | MathPixDataInterface;
  audio: any;
  isCopied: boolean;
}

class MyPATAudioUpload extends Component<MyPATAudioUploadProps, MyPATAudioUploadState> {
  upload: any = null;
  textarea: any = null;
  isOpenUploadDialog: boolean = false;
  inputForPaste: any = null;
  wrapperRef: any = null;

  constructor(props: MyPATAudioUploadProps, state: MyPATAudioUploadState) {
    super(props);
    this.state = {
      isUpload: false,
      uploadImage: '/assets/img/mylibrary/upload-image.png',
      isOpenUploadDialog: false,
      completed: 0,
      mathPixData: null,
      audio: null,
      isCopied: false,
    };
  }

  readFile = (event: any) => {
    const { audioUploadHandler } = this.props;
    let file: any = null;
     if (event.target.files) {
      file = event.target.files[0];
    }
    if (event.dataTransfer && event.dataTransfer.files) {
      file = event.dataTransfer.files[0];
    }

    // focus the upload audio section 
    this.props.focusSection('uploadAudio');
    this.props.showAudioModal(true);
    audioUploadHandler && audioUploadHandler(file);
  };

  render() {
    const { classes } = this.props;
    const { isUpload, isCopied, uploadImage, isOpenUploadDialog, completed } = this.state;

    return (
      <Grid container justify='center'>
        <div
          ref={(ref) => {
            this.wrapperRef = ref;
          }}
          className={classes.dragDropVideoContainer}
        >
          <Grid
            container
            justify='center'
            onDragOver={(event) => {
              event.preventDefault();
            }}
            onDrop={(event) => {
              event.preventDefault();
              //   this.props.handleVideoSelect(event)
              this.readFile(event);
            }}
            style={
              !isUpload && document && document.activeElement && document.activeElement.id === 'inputForPaste'
                ? { opacity: 0.5 }
                : {}
            }
          >
            <div style={{ width: '100%' }} onClick={(e) => {
                  this.upload.value = '';
                  this.upload.click();
                }}>
              <img
                alt='Cancel audio upload'
                src='/assets/svg/learn/videoUploadIcon.svg'
                
                style={{ cursor: 'pointer' }}
              />
            </div>

            <Typography className={classes.dragDropVideoText} component='div' variant='body1' align='center'>
              {isUpload ? 'uploading' : 'Drag and drop audio files to upload'}
            </Typography>
            <input
              id='myInput'
              onChange={(event) => {
                //       this.props.handleVideoSelect(event)
                //   }} type="file" ref={(ref) => this.upload = ref} style={{ display: 'none' }} />
                //   <input id="inputForPaste" type="text" ref={(ref) => this.inputForPaste = ref} onPaste={(event) => { this.props.handleVideoSelect(event) }} style={{ opacity: 0, width: 0 }} />
                this.readFile(event);
              }}
              accept=".mp3, .wav"
              type='file'
              ref={(ref) => (this.upload = ref)}
              style={{ display: 'none' }}
            />
            <input
              id='inputForPaste'
              type='text'
              ref={(ref) => (this.inputForPaste = ref)}
              onPaste={(event) => {
                this.readFile(event);
              }}
              accept=".mp3, .wav"
              style={{ opacity: 0, width: 0 }}
            />
          </Grid>
        </div>
      </Grid>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    openModal: state.showVideoModalReducers.openModal,
  };
}

const mapDispatchToProps = {
    showAudioModal,
    focusSection: focusedSectionActions.focusSection,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(styles)(MyPATAudioUpload));
